const serverLink = (server?: string) => {
    if(!server) {
        server = process.env.VUE_APP_SERVER!;
    }

    if (server.match(new RegExp(/^(http:\/\/|https:\/\/)/)) == null) {
        server = window.location.origin + server;
    }
    return server;
}

export {serverLink}